const defaultstate = { vaults: [], loading: false, error: false }

export default function (state = defaultstate, action) {
    switch (action.type) {
        case 'FETCH_DATA_LOADING':
            return {
                ...state,
                loading: true
            };
        case 'FETCH_DATA_SUCCESS':
            return {
                ...state,
                vaults: action.payload,
                loading: false
            };
        case 'FETCH_DATA_ERROR':
            return {
                ...state,
                loading: false,
                error: true
            };
        case 'NEW_VAULT':
            return {
                ...state,
                vaults: [...state.vaults, action.payload]
            }
        default:
            return state
    }
}